import React from 'react';
import './AboutInfoCards.css';

const AboutInfoCards = ({ settings = {} }) => {
  const {
    cards = [
      {
        title: 'BUFFET-ANGEBOT',
        content: 'Unser Buffet-Style Meal ist unglaublich günstig. Das Essen ist köstlich und alles wird frisch zubereitet. Sie können sich am Buffet so oft bedienen, wie Sie möchten.',
        icon: '🍽️'
      },
      {
        title: 'PIZZA & PASTA',
        content: 'Neben unseren orientalischen Spezialitäten bieten wir auch eine Auswahl an Pizza und Pasta-Gerichten an – perfekt für die ganze Familie!',
        icon: '🍕'
      },
      {
        title: 'ATMOSPHÄRE & SERVICE',
        content: 'Wer eine Mischung aus orientalischen Köstlichkeiten und gemütlicher Atmosphäre sucht, ist beim uns genau richtig. Dieses Lokal ist bekannt für seinen grossartigen Service und freundliches Personal, das immer bereit ist zu helfen. Die Atmosphäre ist charmant und die Preise sind attraktiv. Unsere Küche ist sehr flexibel und freut sich, spezielle Wünsche wenn immer möglich zu erfüllen. Fragen Sie bitte einfach mal. Alles wird mit viel Liebe zubereitet und serviert. Wir hoffen, Sie werden sich bei uns heimisch fühlen und wünschen Ihnen einen guten Appetit.',
        icon: '🏠'
      }
    ],
    background_color = '#f8f9ff',
    text_color = '#333333',
    accent_color = '#4A90E2',
    card_layout = 'grid' // 'grid', 'row', 'masonry'
  } = settings;

  return (
    <section className="about-info-cards" style={{ backgroundColor: background_color, color: text_color }}>
      <div className="about-info-cards__container">
        <div className={`about-info-cards__grid about-info-cards__grid--${card_layout}`}>
          {cards.map((card, index) => (
            <div key={index} className="about-info-cards__card">
              <div className="about-info-cards__card-header">
                <div className="about-info-cards__card-icon" style={{ backgroundColor: accent_color }}>
                  {card.icon}
                </div>
                <h3 className="about-info-cards__card-title" style={{ color: accent_color }}>
                  {card.title}
                </h3>
              </div>
              <div className="about-info-cards__card-content">
                <p className="about-info-cards__card-text">
                  {card.content}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutInfoCards;